import { normalize, schema } from 'normalizr';
import { IApiMessage, messageSchema } from '../../models/message';

const messagesSchema = new schema.Object({
  data: [messageSchema],
});

export type NormalizedMessages = ReturnType<typeof messagesNormalizer>;

export const messagesNormalizer = (messages: IApiMessage) =>
  normalize(messages, messagesSchema);
